/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_A11y_Skiptocontent2Inputs */

const ja_playdata_a11y_skiptocontent2 = /** @type {(inputs: Playdata_A11y_Skiptocontent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本文へスキップ`)
};

const en_playdata_a11y_skiptocontent2 = /** @type {(inputs: Playdata_A11y_Skiptocontent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to content`)
};

/**
* | output |
* | --- |
* | "Skip to content" |
*
* @param {Playdata_A11y_Skiptocontent2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_a11y_skiptocontent2 = /** @type {((inputs?: Playdata_A11y_Skiptocontent2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_A11y_Skiptocontent2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_a11y_skiptocontent2(inputs)
	return en_playdata_a11y_skiptocontent2(inputs)
});
export { playdata_a11y_skiptocontent2 as "playdata_a11y_skipToContent" }